// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__wexKf","filesListContainer":"PosDisputesFiles_filesListContainer__2icQo","filesButton":"PosDisputesFiles_filesButton__2tpWj"};